module.exports = __webpack_public_path__ + "static/media/m7cr93.d27b3a54.png";